import { format, addYears, addDays } from 'date-fns';
import Tokenizr from 'tokenizr';
import { isEmpty } from '@/tools/filters';
import App from '../main';

///////////////////////////////////
// Desine sperare qui hic intras //
///////////////////////////////////

////////////////////
// Search Options //
////////////////////

const GRAPH_QUERY_OPTIONS_DEFAULT = {
    withoutContacts: false,
};

//////////////////////////////
// Search string processing //
//////////////////////////////

let lexer = new Tokenizr();

const LEX_TYPE = {
    OR: 'or',
    AND: 'and',
    AND_NON_BREAKING: 'and-non-breaking',
    NOT: 'not',
    PHRASE: 'phrase',
    GROUP_START: 'group-start',
    GROUP_END: 'group-end',
    FIELD: 'field',
    WORD: 'word',
    EOF: 'EOF',
};

const TYPE = {
    GROUP: 'group',
    OPERATOR: 'operator',
    SEARCH: 'search',
};

lexer.rule(/[ \t\r\n]+(or|[|]{2})[ \t\r\n]+/i, (ctx) => ctx.accept(LEX_TYPE.OR));
lexer.rule(/[ \t\r\n]+(and|&&)[ \t\r\n]+/i, (ctx) => ctx.accept(LEX_TYPE.AND));
lexer.rule(/(^|[ \t\r\n]+)((not[ \t\r\n]+)|!)/i, (ctx) => ctx.accept(LEX_TYPE.NOT));
lexer.rule(/"((?:\\"|[^\r\n])*?)"/, (ctx, match) => {
    ctx.accept(LEX_TYPE.PHRASE, match[1].replace(/\\"/g, '"'));
});
lexer.rule(/[(]/, (ctx) => ctx.accept(LEX_TYPE.GROUP_START));
lexer.rule(/[)]/, (ctx) => ctx.accept(LEX_TYPE.GROUP_END));
lexer.rule(/([a-z_]+):/i, (ctx, match) => {
    ctx.accept(LEX_TYPE.FIELD, match[1]);
});
lexer.rule(/[^ \t\r\n()]+/u, (ctx, match) => {
    if (/(\p{L}|\p{N})/u.test(match[0]) === false) {
        ctx.ignore();
        return;
    }

    if ([LEX_TYPE.OR, LEX_TYPE.AND, LEX_TYPE.NOT].indexOf(match[0].toLowerCase()) === -1) {
        ctx.accept(LEX_TYPE.WORD);
    } else {
        ctx.accept(match[0]);
    }
});
lexer.rule(/\/\/[^\r\n]*\r?\n/, (ctx) => ctx.ignore());
lexer.rule(/[ \t\r\n]+/, (ctx) => ctx.accept(LEX_TYPE.AND_NON_BREAKING));

class ParseError extends Error {}
class ParseValueError extends ParseError {}

const checkFieldValueExists = (field) => {
    if (field instanceof Array) {
        for (const item of field) {
            if (checkFieldValueExists(item)) {
                return true;
            }
        }

        return false;
    }

    if (!(field instanceof Object)) {
        return false;
    }

    if (typeof field.value === 'string') {
        return false;
    }

    if (field.value instanceof Object) {
        return checkFieldValueExists(field.value);
    }

    for (const item of field.value) {
        if (checkFieldValueExists(item)) {
            return true;
        }
    }

    return false;
};

const tokenProcessor = (tokens, isGroup = false, single = false) => {
    const list = [];

    let stateOperator;

    let lastTokenType = null;
    let lastTokenValue = null;

    loop: while (tokens.length) {
        const token = tokens.shift();
        lastTokenType = token.type;
        lastTokenValue = token.value;

        let currentValue = undefined;

        switch (token.type) {
            case LEX_TYPE.EOF:
                break;
            case LEX_TYPE.GROUP_START:
                let group = tokenProcessor(tokens, true);

                if (group.length === 1) {
                    currentValue = group[0];
                } else {
                    currentValue = {
                        type: TYPE.OPERATOR,
                        operator: LEX_TYPE.AND,
                        value: group,
                    };
                }

                if (tokens[0].type === LEX_TYPE.AND_NON_BREAKING) {
                    tokens.shift();
                }

                break;
            case LEX_TYPE.GROUP_END:
                if (isGroup) {
                    isGroup = false;
                    break loop;
                }
                throw new ParseError('Нет начала группы');
            case LEX_TYPE.AND_NON_BREAKING:
            case LEX_TYPE.AND:
            case LEX_TYPE.OR:
                const value = list.pop();
                const operator = token.type;

                if (value === undefined) {
                    if (token.type === LEX_TYPE.AND_NON_BREAKING) {
                        list.push(value);
                        continue;
                    }
                    throw new ParseError(`Нет начального значения перед оператором "${token.value}"`);
                } else if (stateOperator) {
                    if (stateOperator === LEX_TYPE.AND_NON_BREAKING && token.type === LEX_TYPE.AND_NON_BREAKING) {
                        list.push(value);
                        continue;
                    }

                    throw new ParseError(
                        `Использование оператора "${token.value}" (${token.type}) после "${stateOperator}"`
                    );
                }

                if (tokens[0].type === LEX_TYPE.AND_NON_BREAKING) {
                    tokens.shift();
                }

                stateOperator = operator;

                if (typeof value !== 'object' || value.operator !== operator) {
                    list.push({
                        type: TYPE.OPERATOR,
                        operator,
                        value: [value],
                    });
                } else {
                    list.push(value);
                }

                break;
            case LEX_TYPE.NOT:
                try {
                    if (tokens[0].type === LEX_TYPE.AND_NON_BREAKING) {
                        tokens.shift();
                    }

                    currentValue = {
                        type: TYPE.OPERATOR,
                        operator: LEX_TYPE.NOT,
                        value: tokenProcessor(tokens, false, true),
                    };
                } catch (e) {
                    throw e instanceof ParseValueError
                        ? new ParseError(`Нет значения для оператора "${token.value}"`)
                        : e;
                }
                break;
            case LEX_TYPE.FIELD:
                try {
                    if (tokens[0].type === LEX_TYPE.AND_NON_BREAKING) {
                        tokens.shift();
                    }

                    currentValue = {
                        type: TYPE.OPERATOR,
                        operator: LEX_TYPE.FIELD,
                        field: token.value,
                        value: tokenProcessor(tokens, false, true),
                    };
                } catch (e) {
                    throw e instanceof ParseValueError
                        ? new ParseError(`Нет значения для оператора поля "${lastTokenValue}:"`)
                        : e;
                }

                if (checkFieldValueExists(currentValue)) {
                    throw new ParseError(
                        `Значение поиска по полю "${token.value}" не должно содержать вложенного поиска по другому полю`
                    );
                }
                break;
            // LEX_TYPE.PHRASE && LEX_TYPE.WORD
            default:
                currentValue = {
                    type: TYPE.SEARCH,
                    value: token.value,
                };
                break;
        }

        if (currentValue) {
            if (stateOperator) {
                stateOperator = false;
                const prevValue = list.pop();
                prevValue.value = [...prevValue.value, currentValue];
                currentValue = prevValue;
            }

            list.push(currentValue);
        }

        if (single) {
            if (list[0] === undefined) {
                throw new ParseValueError('Ошибка синтаксиса');
            }

            return list[0];
        }
    }

    if (stateOperator && stateOperator !== LEX_TYPE.AND_NON_BREAKING) {
        throw new ParseError(`Нет значения после оператора "${stateOperator}"`);
    }
    if (isGroup) {
        throw new ParseError(`Присутствует незакрытая группа`);
    }

    return list;
};

const getSearchResult = (
    searchString,
    specificField = null,
    isNot = false,
    operator = LEX_TYPE.AND,
    options = GRAPH_QUERY_OPTIONS_DEFAULT
) => {
    const fieldsMap = {
        user_id: 'profile.id',
        fullname: 'profile.fullname',
        name: 'profile.name',
        surname: 'profile.surname',
        patronymic: 'profile.patronymic',
        about: 'profile.about',
        organization: 'career[].organization',
        position: 'career[].position',
        responsibilities: 'career[].responsibilities',
        faculty: 'education[].faculty',
        education_place: 'education[].education_place',
        foreign_place: 'education[].foreign_place',
        specialty_special: 'education[].specialty_special',
        comments: 'comments[].comment',
        ...(options.withoutContacts
            ? {}
            : {
                  email: 'profile.email',
                  reg_email: 'profile.registration_email',
                  phone: 'profile.phone_number',
                  reg_phone: 'profile.registration_phone_number',
              }),
    };

    const intFields = ['profile.id'];

    const fields = specificField ? [fieldsMap[specificField]] : Object.values(fieldsMap);
    const result = [];

    if (searchString instanceof Array && searchString.length === 1) {
        searchString = searchString[0];
    }

    const isArrString = searchString instanceof Array;

    if (isArrString && operator === LEX_TYPE.AND) {
        const andResults = [];

        for (const str of searchString) {
            andResults.push(getSearchResult(str, specificField, isNot, operator, options));
        }

        return andResults.length === 1 ? andResults[0] : `{ and: [ ${andResults.join('\n')} ]}`;
    }

    for (const path of fields) {
        if (!path) {
            throw new ParseError(`Неверное наименование поля: ${specificField}`);
        }

        const isInt = intFields.indexOf(path) !== -1;
        let isArr = isArrString;

        let search = isArr ? searchString.map((v) => ({ ...v })) : { ...searchString };

        let [type, field] = path.split('.');
        let inArr = false;

        if (type.endsWith('[]')) {
            inArr = true;
            type = type.replace(/\[]$/, '');
        }

        if (isInt) {
            if (isArr) {
                search = search
                    .filter((v) => parseInt(v.value).toString() === `${v.value}`)
                    .map((v) => {
                        v.value = parseInt(v.value);
                        return v;
                    });

                if (search.length === 0) {
                    continue;
                }

                if (search.length === 1) {
                    isArr = false;
                    search = search[0];
                }
            } else {
                if (parseInt(search.value).toString() !== `${search.value}`) {
                    continue;
                }
                search.value = parseInt(search.value);
            }
        }

        const valueOp = isInt ? 'eq' : 'contains';
        const queryOperator = operator === LEX_TYPE.AND_NON_BREAKING ? LEX_TYPE.AND : operator;

        const value = isArr
            ? isInt
                ? `{ in: ${JSON.stringify(search.map((v) => v.value))} }`
                : search.map((item) => `{ ${valueOp}: ${JSON.stringify(item.value)} }`).join('\n')
            : `{ ${valueOp}: ${JSON.stringify(search.value)} }`;
        const fieldValue = isArr
            ? isInt
                ? `{ ${field}: ${value} }`
                : `{ ${field}: { ${queryOperator}: [ ${value} ] } }`
            : `{ ${field}: ${value} }`;
        result.push(`{ ${type}: ` + (inArr ? `{ ${isNot ? 'none' : 'some'}: ${fieldValue} }` : fieldValue) + ' }');
    }

    return result.length === 1 ? result[0] : `{ or: [ ${result.join('\n')} ]}`;
};

const processAST = (
    ast,
    field = null,
    not = false,
    operator = LEX_TYPE.AND,
    returnArray = false,
    options = GRAPH_QUERY_OPTIONS_DEFAULT
) => {
    const result = [];
    const searches = [];

    for (const item of ast) {
        if (!(item instanceof Object)) {
            continue;
        }

        if (item.type === TYPE.OPERATOR) {
            switch (item.operator) {
                case LEX_TYPE.FIELD:
                    result.push(processAST([item.value], item.field, not, operator, returnArray, options));
                    break;
                case LEX_TYPE.NOT:
                    result.push(processAST([item.value], field, true, operator, returnArray, options));
                    break;
                default:
                    const data = processAST(item.value, field, not, item.operator, true);

                    const queryOperator = item.operator === LEX_TYPE.AND_NON_BREAKING ? LEX_TYPE.AND : item.operator;

                    result.push(data.length > 1 ? `{ ${queryOperator}: [ ${data.join('\n')} ] }` : data[0]);
            }
        } else {
            searches.push(item);
        }
    }

    if (searches.length) {
        result.push(getSearchResult(searches, field, not, operator, options));
    }

    if (returnArray) {
        return result;
    }

    const queryOperator = operator === LEX_TYPE.AND_NON_BREAKING ? LEX_TYPE.AND : operator;

    return result.length === 1 ? result[0] : `{ ${queryOperator}: [ ${result.join('\n')} ] }`;
};

export const lexParse = (str, options = GRAPH_QUERY_OPTIONS_DEFAULT) => {
    if (!str) {
        return '';
    }

    lexer.input(str.trim());
    const tokens = lexer.tokens();

    return processAST(tokenProcessor([...tokens]), null, false, LEX_TYPE.AND, false, options);
};

/////////////////
// Query build //
/////////////////

export function graphQueryConstructor(
    params = {},
    searchString = '',
    options = GRAPH_QUERY_OPTIONS_DEFAULT,
    tags = [],
    queryType = {
        type: 'users',
        options: {},
    }
) {
    options = {
        ...GRAPH_QUERY_OPTIONS_DEFAULT,
        ...options,
    };

    let isProfile = false;
    let isFavorite = true;
    let isProgress = false;
    let withDrafts = '';
    let withRsvMobileApp = '';
    let importantFieldsFilled = '';
    let isLanguage = false;
    let isNominations = false;
    let isProjectsTypes = false;
    let isEducation = false;
    let isCareer = false;
    let isCourses = false;
    let selectedTags = '';
    let avatar = '';
    let avatarOfficial = '';
    let addresses = '';
    let membershipOwnerId = '';
    let citizenship = '';
    let activities = '';
    let skills = '';
    let jobStatuses = '';
    let lifts = '';
    let ageGt = '';
    let ageLt = '';
    let age = '';
    let government = '';
    let fromSalary = '';
    let toSalary = '';
    let salary = '';
    let gender = '';
    let volunteerWork = '';
    let socialWork = '';
    let languageFilter = '';
    let languageLevel = '';
    let projects = '';
    let projectsExclude = '';
    let projectsPreregistration = '';
    let projectsTypes = '';
    let projectsTypesOld = '';
    let hasProjectSpkOnlyFilters = false;
    let hasProjectOldOnlyFilters = false;
    let projectsOld = '';
    let participantStatuses = '';
    let participantStatusesOld = '';
    let educationLevels = '';
    let educationPlaces = '';
    let educationSpecialties = '';
    let educationDegrees = '';
    let levels = '';
    let competence = '';
    let competenceLevels = '';

    let registrationDate = '';
    let registrationDateFrom = '';
    let registrationDateTo = '';

    let projectsRootGroup = '';
    let projectNominations = '';
    let projectNominationsExclude = '';
    let projectNominationsOld = '';
    let projectNominationsExcludeOld = '';

    let projectRegisteredAt = '';
    let nominationRegisteredAt = '';

    let foreign_institutes_ids = '';
    let event_id = '';
    let event_exclude_id = '';
    let courseStatus = '';
    let courseDateFrom = '';
    let courseDateTo = '';
    let courseDate = '';

    if (
        params.favorite_membership &&
        params.favorite_membership.status &&
        !params.favorite_membership.isFavorite &&
        !params.favorite_membership.membership_owner_id
    ) {
        isFavorite = false;
    }
    if (params.profile) {
        params.profile.gender =
            params.profile.gender === '' || params.profile.gender === undefined || params.profile.gender === null
                ? null
                : `${params.profile.gender}`;
        Object.keys(params.profile).forEach((item) => {
            isProfile = isProfile || !isEmpty(params.profile[item]);
        });
    }
    if (tags.length) {
        isProfile = true;
    }

    if (params.language) {
        Object.keys(params.language).forEach((item) => {
            if (
                (Array.isArray(params.language[item]) && params.language[item].length) ||
                (!Array.isArray(params.language[item]) && params.language[item] !== null)
            ) {
                isLanguage = true;
            }
        });
    }
    if (params.nominations) {
        Object.keys(params.nominations).forEach((item) => {
            if (
                (Array.isArray(params.nominations[item]) && params.nominations[item].length) ||
                (!Array.isArray(params.nominations[item]) && params.nominations[item] !== null)
            ) {
                isNominations = true;
            }
        });
    }

    if (params.course) {
        isCourses = true;
    }

    if (params.education) {
        Object.keys(params.education).forEach((item) => {
            if (
                (Array.isArray(params.education[item]) && params.education[item].length) ||
                (!Array.isArray(params.education[item]) && params.education[item] !== null)
            ) {
                isEducation = true;
            }
        });
    }
    if (params.progress && (params.progress.levels.length || params.progress.competence.length)) {
        isProgress = true;
    }
    if (params.career && params.career.levels && params.career.levels.length) {
        isCareer = true;
    }
    if (isFavorite) {
        if (
            params.favorite_membership &&
            params.favorite_membership.status &&
            params.favorite_membership.isFavorite &&
            params.favorite_membership.membership_owner_id
        ) {
            membershipOwnerId = `
          membership_owner_id: {
            eq: ${params.favorite_membership.membership_owner_id}
          }
        `;
        } else if (
            params.favorite_membership &&
            !params.favorite_membership.status &&
            !params.favorite_membership.isFavorite &&
            params.favorite_membership.membership_owner_id
        ) {
            membershipOwnerId = `
          membership_owner_id: {
            neq: ${params.favorite_membership.membership_owner_id}
          }
        `;
        }
    }

    if (params.profile && params.profile.addresses && params.profile.addresses.length) {
        const FIAS_FIELDS = [
            'country_iso_code',
            'city_fias_id',
            'region_fias_id',
            'area_fias_id',
            'city_district_fias_id',
            'settlement_fias_id',
        ];

        const items = params.profile.addresses.map((item) => {
            const addressFields = [];

            // По какой-то причине оператор точного совпадения eq - не работает
            // оператор contains же применять нельзя, т.к. это вхождение подстроки и будут ненужные/ложные вхождения
            // вследствие этого приходится делать обертку startsWith/endsWith, чтобы получить точное совпадение строки

            FIAS_FIELDS.forEach((field) => {
                if (item.data[field]) {
                    const stringifyData = JSON.stringify(item.data[field]);

                    addressFields.push(`{
                            and: [
                                { profile: { address: { data: { ${field}: { startsWith: ${stringifyData} } } } } }
                                { profile: { address: { data: { ${field}: { endsWith: ${stringifyData} } } } } }
                            ]
                        }`);
                }
            });

            const stringifyData = JSON.stringify(item.value);
            const currentAddressQuery = `{
                    and: [
                        { profile: { address: { value: { startsWith: ${stringifyData} } } } }
                        { profile: { address: { value: { endsWith: ${stringifyData} } } } }
                    ]
                }`;

            return addressFields.length
                ? `{
                    or: [
                        ${currentAddressQuery}
                        { and: [ ${addressFields.join('\n')} ] }
                    ]
                }`
                : currentAddressQuery;
        });

        addresses = items.length === 1 ? items[0] : `{ or: [ ${items.join('\n')} ] }`;
    }

    if (isCourses) {
        if (params.course.courseDateFrom || params.course.courseDateTo) {
            if (params.course.courseDateFrom) {
                courseDateFrom = `{ gte: "${params.course.courseDateFrom}" }`;
            }
            if (params.course.courseDateTo) {
                courseDateTo = `{ lte: "${params.course.courseDateTo}" }`;
            }

            courseDate = `
                created_at: [
                    ${courseDateFrom}
                    ${courseDateTo}
                ]
            `;
        }

        if (params.course.foreign_institutes_id.length) {
            foreign_institutes_ids = `
                or: [
                    ${params.course.foreign_institutes_id.map(
                        (item) => `{ foreign_institute_ids: { contains: "${item.id}"} }`
                    )}
                ]
            `;
        }

        if (params.course.event_id.length || params.course.excludeEventId.length) {
            event_id = `
                event_id: { in: [${params.course.event_id.map((item) => item.id)}] }
            `;

            event_exclude_id = `
                event_id: { in: [${params.course.excludeEventId.map((item) => item.id)}] }
            `;
        }

        if (params.course.courseStatus.length) {
            const statusList = params.course.courseStatus.flatMap((item) => {
                if (item.id === 'confirmed_request') {
                    return ['user_confirmed_request', 'admin_confirmed_request'];
                }
                return item.id;
            });

            courseStatus = `
                status: {
                    in: [${statusList.map((status) => `"${status}"`).join(', ')}]
                }
            `;
        }
    }

    if (isProfile) {
        if (tags.length) {
            selectedTags = `
            foreign_tags_id: {
              in: ${JSON.stringify(tags.map((tag) => tag.id))}
            }
          `;
        }
        if (params.profile.citizenship && params.profile.citizenship.length) {
            citizenship = `
              citizenship: {
                in: ${JSON.stringify(params.profile.citizenship)}
              }
            `;
        }
        if (params.profile.activities && params.profile.activities.length) {
            activities = `
              activity: [
                ${params.profile.activities.map((v) => `{ in: ${JSON.stringify(v.toString())} }`).join('\n')}
              ]
            `;
        }
        if (params.profile.skills && params.profile.skills.length) {
            skills = `
              key_skills: [
                  ${params.profile.skills.map((v) => `{ contains: "${v}" }`).join('\n')}
              ]
            `;
        }
        if (params.profile.jobStatuses && params.profile.jobStatuses.length) {
            jobStatuses = `
              job_search_status: {
                in: ${JSON.stringify(params.profile.jobStatuses.map((v) => parseInt(v)))}
              }
            `;
        }
        if (params.profile.lifts && params.profile.lifts.length) {
            lifts = `
              social_lift_type: {
                in: ${JSON.stringify(params.profile.lifts.map((v) => parseInt(v)))}
              }
            `;
        }
        if (params.profile.ageGt || params.profile.ageLt) {
            if (params.profile.ageGt) {
                const dateLimit = format(addYears(new Date(), -parseInt(params.profile.ageGt)), 'yyyy-MM-dd');
                ageGt = `{ lte: "${dateLimit}" }`;
            }
            if (params.profile.ageLt) {
                const dateLimit = format(
                    addDays(addYears(new Date(), -(parseInt(params.profile.ageLt) + 1)), -1),
                    'yyyy-MM-dd'
                );
                ageLt = `{ gte: "${dateLimit}" }`;
            }
            age = `
                date_of_birth: [
                  ${ageGt}
                  ${ageLt}
                ]
            `;
        }
        if (params.profile.registrationDateFrom || params.profile.registrationDateTo) {
            if (params.profile.registrationDateFrom) {
                registrationDateFrom = `{ gte: "${params.profile.registrationDateFrom}" }`;
            }
            if (params.profile.registrationDateTo) {
                registrationDateTo = `{ lte: "${params.profile.registrationDateTo}" }`;
            }

            registrationDate = `
                registration_date: [
                    ${registrationDateFrom}
                    ${registrationDateTo}
                ]
            `;
        }
        if (params.profile.government) {
            government = `
              has_experience_in_government_service: {
                eq: ${params.profile.government}
              }
            `;
        }
        if (params.profile.fromSalary || params.profile.toSalary) {
            if (params.profile.fromSalary) {
                fromSalary = `{ gte: ${params.profile.fromSalary} }`;
            }
            if (params.profile.toSalary) {
                toSalary = `{ lte: ${params.profile.toSalary} }`;
            }
            salary = `
                salary_level: [
                  ${fromSalary}
                  ${toSalary}
                ]
            `;
        }
        if (params.profile.gender !== null) {
            gender = `gender: { eq: ${params.profile.gender} }`;
        }
        if (params.profile.volunteerWork) {
            volunteerWork = `has_experience_in_volunteer_programms: { eq: ${params.profile.volunteerWork} }`;
        }
        if (params.profile.socialWork) {
            socialWork = `has_experience_in_social_work: { eq: ${params.profile.socialWork} }`;
        }

        if (!isEmpty(params.profile.importantFieldsFilled)) {
            importantFieldsFilled = params.profile.importantFieldsFilled
                ? `important_fields_filled: { eq: true }`
                : `important_fields_filled: { eq: false }`;
        }

        if (!isEmpty(params.profile.withDrafts)) {
            withDrafts = params.profile.withDrafts ? `draft: { eq: true }` : `draft: { eq: false }`;
        }
    }

    if (params.profile && params.profile.withRsvMobileApp) {
        withRsvMobileApp = '{ mobile_apps: { some: { app_name: { eq: "rsv_mobile_app" } } } }';
    }

    if (isLanguage) {
        if (params.language.language) {
            languageFilter = `language_id: { eq: ${params.language.language} }`;
        }
        if (params.language.languageLevel) {
            languageLevel = `proficiency_level_id: { eq: ${params.language.languageLevel} }`;
        }
    }

    if (isNominations) {
        const nominationProjects = params.nominations.projects || [];
        const nominationExcludeProjects = params.nominations.excludeProjects || [];
        const nominationSeasons = params.nominations.seasons || [];
        const nominationExcludeSeasons = params.nominations.excludeSeasonsList || [];
        const nominationStatuses = params.nominations.participantStatuses || [];
        const nominationProjectsTypes = params.nominations.projectsTypes || [];

        const rootProjects = params.nominations.rootProjects || [];
        const projectRegisteredAtDateFrom = params.nominations.projectRegisteredAtDateFrom || null;
        const projectRegisteredAtDateTo = params.nominations.projectRegisteredAtDateTo || null;
        const nominationRegisteredAtDateFrom = params.nominations.nominationRegisteredAtDateFrom || null;
        const nominationRegisteredAtDateTo = params.nominations.nominationRegisteredAtDateTo || null;

        const hasNominations = nominationProjects.length > 0;

        if (nominationProjects.length || nominationExcludeProjects.length) {
            const oldProjectsSeasons = nominationProjects.filter((v) => parseInt(v).toString() === v.toString());
            const spkProjects = nominationProjects.filter((v) => oldProjectsSeasons.indexOf(v) === -1);

            projects = spkProjects.length ? `project_id: { in: ${JSON.stringify(spkProjects)} }` : null;

            projectsExclude = nominationExcludeProjects.length ? `project_id: { in: ${JSON.stringify(nominationExcludeProjects)} }` : null;

            if (oldProjectsSeasons.length) {
                projectsOld = `season_id: { in: ${JSON.stringify(oldProjectsSeasons.map((v) => parseInt(v)))} } `;
            }
        }

        if (
            (rootProjects && rootProjects.length) ||
            projectRegisteredAtDateFrom ||
            projectRegisteredAtDateTo ||
            (projects && !projectsOld)
        ) {
            hasProjectSpkOnlyFilters = true;
        }

        if (projectsOld && !projects) {
            hasProjectOldOnlyFilters = true;
        }

        if (nominationSeasons.length || nominationExcludeSeasons.length) {
            const filterSpk1 = (v) => parseInt(v).toString() === v.toString();
            const filterSpk2 = (v) => spk1.indexOf(v) === -1;

            const spk1 = nominationSeasons.filter(filterSpk1);
            const spk2 = nominationSeasons.filter(filterSpk2);

            const excludeSpk1 = nominationExcludeSeasons.filter(filterSpk1);
            const excludeSpk2 = nominationExcludeSeasons.filter(filterSpk2);

            projectNominations = `nomination_id: { in: ${JSON.stringify(spk2)} }`;
            projectNominationsExclude = `nomination_id: { in: ${JSON.stringify(excludeSpk2)} }`;

            if (spk1.length) {
                projectNominationsOld = `nomination_id: { in: ${JSON.stringify(spk1.map((v) => parseInt(v)))} } `;
            }

            if (excludeSpk1.length) {
                projectNominationsExcludeOld = `nomination_id: { in: ${JSON.stringify(
                    excludeSpk1.map((v) => parseInt(v))
                )} } `;
            }
        }

        if (nominationStatuses.length) {
            const statusIds = nominationStatuses.map((v) => parseInt(v));

            if (projects || !hasNominations) {
                participantStatuses = `status: { in: ${JSON.stringify(statusIds)} } `;
            }

            if (projectsOld || !hasNominations) {
                participantStatusesOld = `participant_status: { in: ${JSON.stringify(statusIds)} }`;
            }
        }

        if (rootProjects.length) {
            projectsRootGroup = `project_group_id: { in: ${JSON.stringify(rootProjects)} }`;
        }

        if (nominationRegisteredAtDateFrom || nominationRegisteredAtDateTo) {
            nominationRegisteredAt = `
                registered_at: [
                    ${nominationRegisteredAtDateFrom ? `{ gte: "${nominationRegisteredAtDateFrom}T00:00:00.000" }` : ''}
                    ${nominationRegisteredAtDateTo ? `{ lte: "${nominationRegisteredAtDateTo}T23:59:59.999" }` : ''}
                ]
            `;
        }

        if (projectRegisteredAtDateFrom || projectRegisteredAtDateTo) {
            projectRegisteredAt = `
                and: {
                    first_in_project: { eq: true }
                    registered_at: [
                        ${projectRegisteredAtDateFrom ? `{ gte: "${projectRegisteredAtDateFrom}T00:00:00.000" }` : ''}
                        ${projectRegisteredAtDateTo ? `{ lte: "${projectRegisteredAtDateTo}T23:59:59.999" }` : ''}
                    ]
                }
            `;
        }

        if (nominationProjectsTypes.length) {
            const spkProjectTypes = nominationProjectsTypes.map((v) => parseInt(v.field_id));
            const oldProjectTypes = [];

            nominationProjectsTypes
                .filter(
                    (v) =>
                        ['centres_of_competitions', 'contest', 'project', 'facetoface_event'].indexOf(v.field_name) > -1
                )
                .forEach((v) => {
                    if (v.field_name === 'project') {
                        oldProjectTypes.push('project', 'internship');
                    } else if (v.field_name === 'contest') {
                        oldProjectTypes.push('contest', 'contests');
                    } else if (v.field_name === 'facetoface_event') {
                        oldProjectTypes.push('facetoface_event', 'events');
                    } else {
                        oldProjectTypes.push(v.field_name);
                    }
                });

            if (projects || !hasNominations) {
                if (spkProjectTypes.length) {
                    projectsTypes = `project_type: { in: ${JSON.stringify(spkProjectTypes)} }`;
                } else {
                    projects = null;
                    participantStatuses = null;
                    projectNominations = null;
                }
            }

            if (projectsOld || !hasNominations) {
                if (oldProjectTypes.length) {
                    projectsTypesOld = `project_type: { in: ${JSON.stringify(oldProjectTypes)} }`;
                } else {
                    projectsOld = null;
                    participantStatusesOld = null;
                    projectNominationsOld = null;
                }
            }
        }

        if (
            projects &&
            !(
                participantStatuses ||
                projectNominations ||
                projectRegisteredAtDateFrom ||
                projectRegisteredAtDateTo ||
                nominationRegisteredAtDateFrom ||
                nominationRegisteredAtDateTo
            )
        ) {
            projectsPreregistration = `{ preregistrations_on_project: {
             some: { ${projects} }
             } }`;
        }
    }

    if (isProgress) {
        if (params.progress.competence.length) {
            competence = `competence_id: {
          in: ${JSON.stringify(params.progress.competence.map((v) => parseInt(v)))}
        }`;
        }
        if (params.progress.levels.length) {
            competenceLevels = `competence_level: {
          in: ${JSON.stringify(params.progress.levels.map((v) => v))}
        }`;
        }
    }
    if (isEducation) {
        if (params.education.educationLevels && params.education.educationLevels.length) {
            educationLevels = `
      foreign_level_id: {
        in:  ${JSON.stringify(params.education.educationLevels.map((v) => parseInt(v)))}
      }
    `;
        }
        if (params.education.educationPlaces && params.education.educationPlaces.length) {
            const controlCharsRX = /[\u0000-\u001F\u007F-\u009F\u061C\u200E\u200F\u202A-\u202E\u2066-\u2069\u200b]/g;

            educationPlaces = `
      foreign_place: {
        in:  ${JSON.stringify(params.education.educationPlaces.map((v) => v.replace(controlCharsRX, '')))}
      }
    `;
        }
        if (params.education.educationSpecialties && params.education.educationSpecialties.length) {
            educationSpecialties = `
      foreign_specialty: {
        in:  ${JSON.stringify(params.education.educationSpecialties)}
      }
    `;
        }
        if (params.education.educationDegrees && params.education.educationDegrees.length) {
            educationDegrees = `
      foreign_degree_id: {
        in:  ${JSON.stringify(params.education.educationDegrees.map((v) => parseInt(v)))}
      }
    `;
        }
    }
    if (isCareer) {
        if (params.career.levels && params.career.levels.length) {
            levels = `
      foreign_position_level_id: {
        in:  ${JSON.stringify(params.career.levels.map((v) => parseInt(v)))}
      }
    `;
        }
    }

    let favorite;
    if (
        params.favorite_membership &&
        params.favorite_membership.status &&
        params.favorite_membership.isFavorite &&
        params.favorite_membership.membership_owner_id
    ) {
        favorite = `
        {
          favorite_membership: {
            some: {
              ${membershipOwnerId}
            }
          }
        }
      `;
    } else if (
        params.favorite_membership &&
        !params.favorite_membership.status &&
        !params.favorite_membership.isFavorite &&
        params.favorite_membership.membership_owner_id
    ) {
        favorite = `
        {
          favorite_membership: {
            all: {
              ${membershipOwnerId}
            }
          }
        }
      `;
    }

    const career = `
    {
      career: {
        some: {
          ${levels}
        }
      }
    }
  `;
    const education = `
    {
      education: {
        some: {
          ${educationLevels}
          ${educationPlaces}
          ${educationSpecialties}
          ${educationDegrees}
        }
      }
    }
  `;

    const progress = `
  {
    progress: {
      some: {
        ${competence}
        ${competenceLevels}
      }
    }
  }
  `;

    const nominationsConditionQuery =
        !hasProjectOldOnlyFilters &&
        [
            projects,
            participantStatuses,
            projectNominations,
            projectsTypes,
            projectsRootGroup,
            projectRegisteredAt,
            nominationRegisteredAt,
        ]
            .filter((v) => !!v)
            .join('\n');

    const nominationsExcludeQuery = projectsExclude || projectNominationsExclude ? `{
            nominations: {
                none: {
                    ${projectsExclude}
                    ${projectNominationsExclude}
                }
            }
        }` : '';

    const preregistrationsOnProjectExclude = projectsExclude ? `{
            preregistrations_on_project: {
                none: {
                    ${projectsExclude}
                }
            }
        }` : '';

    const nominations = nominationsConditionQuery
        ? `
        {
            or: [
                {
                    nominations: {
                        some: {
                            ${nominationsConditionQuery}
                        }
                    }
                }
                ${projectsPreregistration}
            ],
        }
        ${nominationsExcludeQuery}
        ${preregistrationsOnProjectExclude}
    ` : '';

    const onlyNewProjects = !!(
        hasProjectSpkOnlyFilters ||
        projectsRootGroup ||
        projectRegisteredAt
    );

    const seasonOldConditionQuery =
        !hasProjectSpkOnlyFilters &&
        [projectsOld, participantStatusesOld, projectNominationsOld, projectsTypesOld, nominationRegisteredAt].filter((v) => !!v).join('\n');

    const seasonOld =
        !onlyNewProjects && seasonOldConditionQuery
            ? `
    {
      depricated_project_nominations: {
        some: {
            ${seasonOldConditionQuery}
        }
      }
    }
  `
            : '';

    const projectsRequest =
        hasProjectSpkOnlyFilters && hasProjectOldOnlyFilters
            ? `
            {
              nominations: {
                some: {
                  project_id: { in: ["00000000-0000-0000-0000-000000000000"] }
                }
              }
            }
        `
            : nominations || seasonOld
            ? `
            {
              or: [
                ${nominations}
                ${seasonOld}
              ]
            }
          `
            : '';

    const courses =
        foreign_institutes_ids || event_id || courseStatus || courseDate
            ? `
            {
                courses: {
                    some: {
                        ${courseDate}
                        ${foreign_institutes_ids}
                        ${event_id}
                        ${courseStatus}
                    }
                    ${event_exclude_id ? `none: { ${event_exclude_id} }` : ''}
                }
            }
        `
            : '';

    const language = `
    {
      language_proficiency: {
        some: {
          ${languageFilter}
          ${languageLevel}
        }
      }
    }
  `;

    const profileQueryItems = [
        citizenship,
        selectedTags,
        activities,
        skills,
        lifts,
        jobStatuses,
        age,
        government,
        salary,
        gender,
        volunteerWork,
        socialWork,
        registrationDate,
        withDrafts,
        importantFieldsFilled,
    ].filter((v) => v && v.trim());
    const profile = profileQueryItems.length ? `{ profile: { ${profileQueryItems.join('\n')} } }` : '';

    const whereQueryArr = [
        addresses,
        `${isFavorite && favorite ? favorite : ''}`,
        `${isProfile && profile ? profile : ''}`,
        `${isLanguage && language ? language : ''}`,
        `${isNominations && projectsRequest ? projectsRequest : ''}`,
        `${isEducation && education ? education : ''}`,
        `${isCareer && career ? career : ''}`,
        `${isProgress && progress ? progress : ''}`,
        `${isCourses && courses ? courses : ''}`,
        `${withRsvMobileApp ? withRsvMobileApp : ''}`,
        `${searchString}`,
    ].filter((v) => !!v);

    const whereQuery = whereQueryArr.length === 1 ? whereQueryArr[0] : `{ and: [ ${whereQueryArr.join('\n')} ] }`;

    App.$store.dispatch('loadUsersQueryData', `where: ${whereQuery}`);
    App.$store.dispatch('setUsersQueryFilter', { params, searchString, options, tags });
    if (queryType.type === 'users') {
        return `query users(
        $skip: Int
      ){
        users(
          take: 20
          skip: $skip
          order: {
            profile: {
              surname: ASC
            }
          }
          where: ${whereQuery}
        )
        {
          totalCount
          pageInfo {
            hasNextPage
            hasPreviousPage
          }
          items {
            id
            highlights {
                field
                highlights
            }
            profile {
               id
              avatar_official_file_uri
              avatar_file_uri
              age
              gender
              address {
                value
                data {
                    country
                    postal_code
                    country_iso_code
                    fias_id
                    city_fias_id
                    region_fias_id
                    area_fias_id
                    city_district_fias_id
                    settlement_fias_id
                }
              }
              deleted_at
              is_no_work_experience
              date_of_birth
              name
              patronymic
              surname
              foreign_tags_id
              ${options.withoutContacts ? '' : 'email'}
              fullname
              registration_date
              draft
              about
              important_fields_filled
            }
            nominations {
                id
                project_id
                registered_at
                status
                project_type
                first_in_project
            }
            career(
              order: {
                data_start: DESC
              }
            ) {
              organization
              responsibilities
              is_until_now
              position
              data_start
              date_end
            }
            education {
              education_place
              foreign_place
              faculty
              specialty_special
            }
            favorite_membership {
              membership_owner_id
            }
            comments {
                user_id
                comment
            }
          }
        }
      }`;
    } else if (queryType.type === 'monthRegistrationDistribution') {
        return `query MonthRegistrationDistribution {
            monthRegistrationDistribution(year: ${queryType.options.year}, where: ${whereQuery}) {
                months {
                    month
                    totalUsers
                }
            }
        }`;
    } else if (queryType.type === 'lastActivityMonthDistribution') {
        return `query LastActivityMonthDistribution {
            lastActivityMonthDistribution(year: ${queryType.options.year}, where: ${whereQuery}) {
                months {
                    month
                    numberOrActiveUsers
                }
            }
        }`;
    } else if (queryType.type === 'spk2ProjectsDistributionPerMonth') {
        return `query Spk2ProjectsDistributionPerMonth {
          spk2ProjectsDistributionPerMonth(projectId: "${queryType.options.projectId}", year: ${queryType.options.year}) {
            perMonth {
                month
                totalUsers
            }
          }
      }`;
    } else if (queryType.type === 'geographicDistribution') {
        return `query GeographicDistribution {
        geographicDistribution(where: ${whereQuery}) {
          totalUsersWithForeignAddress
          totalUsersWithoutAddress
          totalUsers
          federalDistricts {
              name
              totalUsers
          }
          federalSignifacanceCities {
              name
              okato
              totalUsers
          }
          federalSubjects {
              name
              okato
              totalUsers
          }
          countries {
              countryName
              countryIsoCode
              totalUsers
          }
        }
      }`;
    } else if (queryType.type === 'ageGroupsDistribution') {
        return `query AgeGroupsDistribution {
        ageGroupsDistribution(where: ${whereQuery}) {
          totalUsers
          ageGroups {
            total
            ageInterval {
                from
                to
                isDoubleSided
                isLeftSideRestricted
                isRightSideRestricted
            }
          }
        }
      }`;
    } else if (queryType.type === 'genderDistribution') {
        return `query GenderDistribution {
        genderDistribution(where: ${whereQuery}) {
          totalUsers
          genders {
            gender
            totalUsers
          }
        }
      }`;
    } else if (queryType.type === 'higherEducationInstitutionDistribution') {
        return `query HigherEducationInstitutionDistribution {
        higherEducationInstitutionDistribution(where: ${whereQuery}) {
          totalUsers
          higherEducationInsitutions {
              foreignPlaceId
              foreignPlaceName
              totalUsers
          }
        }
      }`;
    } else if (queryType.type === 'educationLevelDistribution') {
        return `query EducationLevelDistribution {
        educationLevelDistribution(where: ${whereQuery}) {
          totalUsersWithoutEducation
          totalUsers
          educationLevels {
              foreignLevelId
              foreignLevel
              totalUsers
          }
        }
      }`;
    } else if (queryType.type === 'competenceDistribution') {
        return `query CompetenceDistribution {
        competenceDistribution(type: "soft", where: ${whereQuery}) {
          totalUsers
          competencies {
            competenceId
            totalUsers
            levels {
                competenceLevel
                totalUsers
            }
          }
        }
      }`;
    } else if (queryType.type === 'courseDistribution') {
        return `query CourseDistribution {
        courseDistribution(where: ${whereQuery}) {
          totalUsers
          courses {
              courseId
              courseName
              totalUsersWhoCompleted
              totalUsersWhoStarted
          }
        }
      }`;
    } else if (queryType.type === 'projectsDistribution') {
        return `query ProjectsDistribution {
         projectsDistribution(where: ${whereQuery}) {
          totalUsers
          projects {
              projectId
              isOldProjectVersion
              totalUsers
              nominations {
                  nominationId
                  totalUsers
                  years {
                      year
                      totalUsers
                  }
              }
          }
          projectRegistrationYears {
              year
              totalUsers
          }
        }
      }`;
    }
}
